export const QUERY_KEY_REPAIRTIMES = "basket__CustomRepairTimes"
export const QUERY_KEY_REPAIRTIME_LISTS = "basket__CustomRepairTimeLists"
export const DEFAULTS_KEY = "basket____CustomRepairTimesDefaults"
